import { CountryId, CountryIdUtil, iZettleMarket } from "./countryId"

export enum Currency {
  BRL = "BRL",
  DKK = "DKK",
  EUR = "EUR",
  GBP = "GBP",
  MXN = "MXN",
  NOK = "NOK",
  SEK = "SEK",
  USD = "USD",
}

const currencyMap = {
  [iZettleMarket.GB]: Currency.GBP,
  [iZettleMarket.SE]: Currency.SEK,
  [iZettleMarket.DK]: Currency.DKK,
  [iZettleMarket.NO]: Currency.NOK,
  [iZettleMarket.FI]: Currency.EUR,
  [iZettleMarket.DE]: Currency.EUR,
  [iZettleMarket.ES]: Currency.EUR,
  [iZettleMarket.NL]: Currency.EUR,
  [iZettleMarket.FR]: Currency.EUR,
  [iZettleMarket.IT]: Currency.EUR,
  [iZettleMarket.MX]: Currency.MXN,
  [iZettleMarket.BR]: Currency.BRL,
  [iZettleMarket.US]: Currency.USD,
}

export const CurrencyUtil = {
  fromCountry: (country: CountryId | iZettleMarket): Currency => {
    if (!CountryIdUtil.isSupportedMarket(country)) {
      throw new Error(`'${country}' is not a supported market, could not get currency.`)
    }

    return currencyMap[country]
  },
}
